// Static firm NAP (Name/Address/Phone) + brand data.
// Hardcoded (not fetched) so SEO meta tags & JSON-LD are available immediately on render.
export const FIRM = {
  name: "Rinnou & Associates, P.C.",
  shortName: "Rinnou & Associates",
  founder: "Jouliana Rinnou",
  founderTitle: "Founding Attorney",
  phoneDisplay: "(972) 705-9184",
  phoneTel: "+19727059184",
  email: "info@rinnoulaw.com",
  addressLine1: "9330 Lyndon B Johnson Fwy Ste 932",
  city: "Dallas",
  state: "TX",
  zip: "75243",
  foundedYear: 2001,
  hours: "Mon-Thu: 10:00 AM - 5:00 PM, Fri: 10:00 AM - 1:00 PM",
  siteUrl:
    (typeof process !== "undefined" && process.env && process.env.REACT_APP_BACKEND_URL) ||
    "https://rinnoulaw.com",
  logoFull: "/images/logo-full.png",
  logoSeal: "/images/logo-seal.png",
  socials: {
    facebook: "https://www.facebook.com/",
    linkedin: "https://www.linkedin.com/",
  },
};

export const PRACTICE_AREA_SLUGS = [
  "family-immigration",
  "employment-immigration",
  "business-immigration",
  "us-citizenship",
  "business-law",
  "wills-trusts",
  "family-law",
];

export const PRACTICE_AREAS_NAV = [
  { slug: "family-immigration", title: "Family Immigration", icon: "Users" },
  { slug: "employment-immigration", title: "Employment Immigration", icon: "Briefcase" },
  { slug: "business-immigration", title: "Business Immigration", icon: "Building2" },
  { slug: "us-citizenship", title: "US Citizenship", icon: "Award" },
  { slug: "business-law", title: "Business Law", icon: "Landmark" },
  { slug: "wills-trusts", title: "Wills & Trusts", icon: "ScrollText" },
  { slug: "family-law", title: "Family Law", icon: "HeartHandshake" },
];

// Contextual editorial photography per practice area — used on hero/detail
// pages so each practice area feels distinct rather than a repeated stock shot.
export const PRACTICE_AREA_IMAGES = {
  "family-immigration": "https://images.unsplash.com/photo-1553697388-94e804e2f0f6",
  "employment-immigration": "https://images.unsplash.com/photo-1553697388-94e804e2f0f6",
  "business-immigration": "https://images.unsplash.com/photo-1553697388-94e804e2f0f6",
  "us-citizenship": "https://images.unsplash.com/photo-1553697388-94e804e2f0f6",
  "business-law": "https://images.unsplash.com/photo-1758691736933-bb0f88fe2e0c",
  "wills-trusts": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85",
  "family-law": "https://images.unsplash.com/photo-1573495804664-b1c0849525af",
};

// Subtle photographic backdrops layered behind dark hero headers on
// content-only pages (About/Case Results/Insights/Locations) so each page
// feels visually distinct rather than repeating the same flat navy block.
export const PAGE_HERO_IMAGES = {
  about: "https://images.unsplash.com/photo-1739285388427-d6f85d12a8fc",
  caseResults: "https://images.unsplash.com/photo-1436450412740-6b988f486c6b",
  insights: "https://images.unsplash.com/photo-1619771766980-368d32e44b82",
  location: "https://images.unsplash.com/photo-1621904878414-d4ca4756bd7e",
};

// Category-representative imagery for the Insights "featured article" card.
export const INSIGHT_CATEGORY_IMAGES = {
  Immigration: "https://images.unsplash.com/photo-1687992176093-6417a93fa3d0",
  "Family Law": "https://images.unsplash.com/photo-1573495804664-b1c0849525af",
  "Business Law": "https://images.unsplash.com/photo-1758691736933-bb0f88fe2e0c",
  "Wills & Trusts": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85",
};

export const CASE_TYPE_OPTIONS = [
  "Family Immigration",
  "Employment Immigration",
  "Business Immigration",
  "US Citizenship",
  "Business Law",
  "Wills & Trusts",
  "Family Law",
  "Other / Not Sure",
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Case Results", to: "/case-results" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

// Nearby DFW-metro cities we serve, used for local SEO landing pages
// (/locations/:slug). City names are proper nouns and stay the same in both
// languages; distance phrases are localized since they include direction words.
export const CITIES = [
  {
    slug: "plano",
    name: "Plano",
    distanceEn: "20 miles north of downtown Dallas",
    distanceEs: "20 millas al norte del centro de Dallas",
  },
  {
    slug: "richardson",
    name: "Richardson",
    distanceEn: "15 miles north of downtown Dallas",
    distanceEs: "15 millas al norte del centro de Dallas",
  },
  {
    slug: "garland",
    name: "Garland",
    distanceEn: "18 miles northeast of downtown Dallas",
    distanceEs: "18 millas al noreste del centro de Dallas",
  },
  {
    slug: "irving",
    name: "Irving",
    distanceEn: "12 miles west of downtown Dallas",
    distanceEs: "12 millas al oeste del centro de Dallas",
  },
  {
    slug: "frisco",
    name: "Frisco",
    distanceEn: "26 miles north of downtown Dallas",
    distanceEs: "26 millas al norte del centro de Dallas",
  },
  {
    slug: "mckinney",
    name: "McKinney",
    distanceEn: "32 miles north of downtown Dallas",
    distanceEs: "32 millas al norte del centro de Dallas",
  },
  {
    slug: "arlington",
    name: "Arlington",
    distanceEn: "20 miles southwest of downtown Dallas",
    distanceEs: "20 millas al suroeste del centro de Dallas",
  },
  {
    slug: "southlake",
    name: "Southlake",
    distanceEn: "28 miles northwest of downtown Dallas",
    distanceEs: "28 millas al noroeste del centro de Dallas",
  },
  {
    slug: "denton",
    name: "Denton",
    distanceEn: "40 miles north of downtown Dallas",
    distanceEs: "40 millas al norte del centro de Dallas",
  },
  {
    slug: "grapevine",
    name: "Grapevine",
    distanceEn: "25 miles northwest of downtown Dallas",
    distanceEs: "25 millas al noroeste del centro de Dallas",
  },
  {
    slug: "fort-worth",
    name: "Fort Worth",
    distanceEn: "32 miles west of downtown Dallas",
    distanceEs: "32 millas al oeste del centro de Dallas",
  },
  {
    slug: "lewisville",
    name: "Lewisville",
    distanceEn: "25 miles northwest of downtown Dallas",
    distanceEs: "25 millas al noroeste del centro de Dallas",
  },
  {
    slug: "allen",
    name: "Allen",
    distanceEn: "25 miles north of downtown Dallas",
    distanceEs: "25 millas al norte del centro de Dallas",
  },
  {
    slug: "mesquite",
    name: "Mesquite",
    distanceEn: "15 miles east of downtown Dallas",
    distanceEs: "15 millas al este del centro de Dallas",
  },
  {
    slug: "carrollton",
    name: "Carrollton",
    distanceEn: "20 miles northwest of downtown Dallas",
    distanceEs: "20 millas al noroeste del centro de Dallas",
  },
  {
    slug: "rockwall",
    name: "Rockwall",
    distanceEn: "25 miles northeast of downtown Dallas",
    distanceEs: "25 millas al noreste del centro de Dallas",
  },
];
